"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.redirectDictionary = void 0;
exports.redirectDictionary = {
    goToUSLabel: 'USA Redirect - Go to US site',
    stayOnGlobalLabel: 'USA Redirect - Stay on global',
    redirectMessage: 'USA Redirect - Message',
};
